import { styled } from "@mui/material/styles";
import { Button, Grid, Paper } from "@mui/material";
import { Box } from "@mui/system";
import { ColorsEnum } from "common/theme/colors";

const SIDEBAR_WIDTH = 320;

export const StyledButton = styled(Button)(({ theme }) => ({
    justifyContent: "flex-start", 
    textTransform: "none", 
    color: theme.palette.text.primary, 
    padding: `${theme.spacing(1)} ${theme.spacing(2)} `, 
    borderRadius: '10px'
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    padding: "10px 8px 8px 10px",
    gap: theme.spacing(1),
    borderRadius: 0,
    position: "relative",
}));

export const StyledBoxPaperContainer = styled(Box)(({ theme }) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: SIDEBAR_WIDTH,
    height: "100vh",
    zIndex: 1200,
}));

export const StyledBox = styled(Box)(({ theme }) => ({
    position: "fixed",
    top: 16,
    left: 16,
    zIndex: 10,
    display: "flex"
}));

export const StyledGrid = styled(Grid)(({ theme }) => ({
    height: "100%",
    minHeight: 0,
    maxWidth: SIDEBAR_WIDTH,
    flexBasis: SIDEBAR_WIDTH,
    flexShrink: 0,
    position: "relative",
}));

export const SectionHeader = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(0.5),
    gap: theme.spacing(1),
}));

export const SectionHeaderTitle = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
}));

export const SectionToggle = styled("button")(({ theme }) => ({
    border: "none",
    background: "transparent",
    padding: `${theme.spacing(1)} 0`,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    cursor: "pointer",
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    lineHeight: theme.typography.body2.lineHeight,
}));
